import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from '../Header/PageHeader';
import TabView from '../tabView/TabView';
import AccountTab from './AccountTab';
import ApiTokensTab from './ApiTokensTab';
import RoleEnum from '../../enums/RoleEnum';
import stylesCommon from '../../styles/component.module.scss';

const ROLES_HIDING_API_TOKENS = [RoleEnum.TRIAL_ORG_ADMIN.name, RoleEnum.TRIAL_USER.name];

const ProfilePage = () => {
  const roles = useSelector((state) => state.auth?.user?.roles) ?? [];
  const hideApiTokens = ROLES_HIDING_API_TOKENS.some((roleName) => roles.includes(roleName));
  const location = useLocation();
  const navigate = useNavigate();

  // A Slack "please link your account" reply lands here with this param -
  // jump straight to the API Tokens tab and open the create-token modal.
  const slackLinkToken = useMemo(
    () => new URLSearchParams(location.search).get('slackLinkToken'),
    [location.search]
  );

  const clearSlackLinkToken = () => {
    navigate(location.pathname, { replace: true });
  };

  const tabsData = [
    { name: 'Account', component: <AccountTab /> },
    ...(hideApiTokens
      ? []
      : [{
          name: 'API Tokens',
          component: (
            <ApiTokensTab slackLinkToken={slackLinkToken} onSlackLinkHandled={clearSlackLinkToken} />
          ),
        }]),
  ];
  const apiTokensTabIndex = tabsData.findIndex((tab) => tab.name === 'API Tokens');
  const parentActiveTab = slackLinkToken && apiTokensTabIndex >= 0 ? apiTokensTabIndex : undefined;

  return (
    <Box className={stylesCommon['page-container']}>
      <PageHeader
        title="Profile"
        description="Manage your profile information and preferences"
        breadcrumbItems={[{ label: "Profile" }]}
      />
      <Box sx={{ width: '100%', paddingX: 2, paddingTop: 0 }} className={stylesCommon['cover-container-col']}>
        <TabView tabsData={tabsData} parentActiveTab={parentActiveTab} />
      </Box>
    </Box>
  );
};

export default ProfilePage;
